export enum SelectType {
  DEFAULT = "default",
  ELEVATED = "elevated",
}
